import Vue from 'vue'

export const EventBus = new Vue()


// WEBPACK FOOTER //
// ./resources/js/helpers/bus.js